<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2023-07-05 16:31:19
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-14 17:11:02
 * @FilePath: \partner.chaoyongtuan.com\src\views\shopManage\selectionDecoration\list\components\tableCells\titleCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div>
		<div class="showcase-style1 flex">
			<img style="width: 100px;" :src="require(`@/assets/public/showcase-style${row.type || '1'}.png`)" alt="" />
			<el-popover placement="bottom" :width="413" trigger="hover">
				<div class="align-center pl-20 pr-20 pt-20 pb-20">
					<p class="yx-color-pure-1 font-h4-regular">橱窗样式{{ row.type }}</p>
					<p class="font-h4-regular yx-color-blue-6">可自定义橱窗背景图；点击整体可跳转到指定的集合页；</p>
					<p class="font-h4-regular yx-color-blue-6 mb-10">可向右滑动查看10个商品</p>
					<img :src="require(`@/assets/public/showcase-img${row.type  || '1'}.png`)" style="width: 349px;" alt="" />
				</div>
				<p class="yx-color-primary ml-12 font-h4-regular cursor-pointer" slot="reference">示例</p>
			</el-popover>
		</div>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
	mixins: [mixin],
	data() {
		return {};
	},
};
</script>
<style lang="less" scoped></style>
